import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import Snapchat from "../../assets/snapchat.png"

export const STRINGS = {
  WEBSITE_URL: "https://brochat.chat",
  API_URL:"https://app.brochat.chat/api/", 

  questions: [
    "Who would you ship me with?",
    "If you could describe me in one word, what would it be?",
    "Tell me a secret you've never told anyone.",
    "Guess who I like?",
    "Name a song that reminds you of me.",
    "Share the funniest moment we've had together.",
    "If you could take me anywhere in the world, where would it be?",
    "Describe our friendship using only emojis.",
    "Reveal something you wish I knew about you.",
    "If you had to give me a nickname, what would it be?",
    "What do you really think of me?",
    "Send me your honest opinion!",
    "Guess who I like?",
    "What's your favorite memory with me?",
    "What's your favorite thing about me?",
  ],

  
  answers: [
    "You always make me smile!",
    "Honestly, I think you're amazing.",
    "I wish we talked more often.",
    "You have the best sense of humor.",
    "I admire your confidence.",
    "You're the friend everyone wishes they had.",
    "I still remember that time we laughed until we cried.",
    "You're my favorite person to hang out with.",
    "I secretly look up to you.",
    "You give the best advice.",
    "I love how genuine you are.",
    "You're the reason I enjoy coming to school.",
    "I wish I could tell you how much you mean to me.",
    "You're so talented, never doubt yourself.",
    "I think you're really cute.",
    "You always know how to cheer me up.",
    "I trust you with all my secrets.",
    "You're the first person I think of when something happens.",
    "I hope we stay friends forever.",
    "You inspire me to be a better person.",
    "I love our late-night conversations.",
    "You're the best at keeping secrets.",
    "I wish I had your confidence.",
    "You make every moment memorable.",
    "I'm grateful to have you in my life.",
    "You're the best listener.",
    "I love your energy and positivity.",
    "You always know what to say.",
    "You're my go-to person for everything.",
    "I hope you know how special you are.",
  ],

  platforms: [
    { name: 'WhatsApp', icon: <FaWhatsapp size={25} />, color: 'bg-green-500 text-white', shape: 'circle' },
    { name: 'Instagram', icon: <FaInstagram size={25} />, color: 'bg-gradient-to-r from-pink-500 to-yellow-500 text-white', shape: 'circle' },
    {
      name: 'Snapchat',
      icon: (
        <img
          src={Snapchat}
          alt="Snapchat"
          className="w-5 h-5 object-contain"
        />
      ),
      color: 'bg-yellow-300 text-black',
      shape: 'squircle',
    },
  ],

  LOCAL_STORAGE_KEY: "ngl-registration-data",

  months: [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ],

  CLOUD_NAME: "dw7fvs6i2",
  UPLOAD_PRESET: "ml_default"
};